import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { fetchApi } from '../../services/api';
import JsonPretty from '../JsonPretty';

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    auditlog: AuditLogData[];
    isLoading: boolean;
    childId: number;
}

type AuditLogData = {
    AuditLogID: number;
    UserName: string;
    OldValues: string;
    NewValues: string;
    DateTime: Date;
}

export default class AuditLog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            auditlog: [],
            childId: 0,
        }
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestAuditLogs(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.auditlog && this.state.childId != childId) {
            this.requestAuditLogs(childId);
        }
    }

    public render() {
        return <div>
            <br/>
            <table className="table">
                <thead>
                    <tr>
                        <th>User</th>
                        <th>Timestamp</th>
                        <th>Old Values</th>
                        <th>New Values</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.auditlog.map((note, index) => {
                        return <tr key={index}>
                                <td>{note.UserName || "SYSTEM"}</td>
                                <td>{moment.utc(note.DateTime).local().format("YYYY-MM-DD HH:mm")}</td>
                                <td><JsonPretty json={note.OldValues} /></td>
                                <td><JsonPretty json={note.NewValues} /></td>
                            </tr>
                    })}
                </tbody>
            </table>
        </div>
    }

    private requestAuditLogs(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/AuditLog/Children/${childId}`)
            .then((auditlog: AuditLogData[]) => {
                this.setState({ isLoading: false, auditlog });
            });
    }
}
